<template>
	<div class="innerBox">
		<h2 class="mb-4">Complain</h2>
		<div class="row" v-if="woDetail">
			<div class="col-md-4 align-middle" :class="{'mb-4' : mobile}">
				<img :src="env.baseImage + '/' + woDetail.image[0]" style="max-height:350px"  class="w-100" v-if="woDetail.image[0]" alt="No Image">
				<h4 v-else class="text-center">No Image Available</h4>
			</div>
			<div class="col-md-8">
				<div class="row">
					<div class="col-md-6">
						<table class="wo-stats">
						<tr>
							<th>Work Order ID:</th>
							<td>{{ woDetail.work_order_id }}</td>
						</tr>
						<tr>
							<th>No Mesin:</th>
							<td>{{ woDetail.nomor_mesin }}</td>
						</tr>
						<tr>
							<th>No Rangka:</th>
							<td>{{ woDetail.nomor_rangka }}</td>
						</tr>
						<tr>
							<th>No Polisi:</th>
							<td>{{ woDetail.nomor_polisi }}</td>
						</tr>
						<tr>
							<th>Tipe:</th>
							<td>{{ woDetail.tipe }}</td>
						</tr>
						</table>
					</div>
					<div class="col-md-6">
						<table class="wo-stats">
						<tr>
							<th>Tanggal Masuk:</th>
							<td>{{ woDetail.tanggal_masuk }}</td>
						</tr>
						<tr>
							<th>Pelanggan:</th>
							<td>{{ woDetail.pelanggan }}</td>
						</tr>
						<tr>
							<th>CSO:</th>
							<td>{{ woDetail.cso }}</td>
						</tr>
						<tr>
							<th>Merek:</th>
							<td>{{ woDetail.merek }}</td>
						</tr>
						
						</table>
					</div>
				</div>
			</div>
    	</div>

		<div class="mt-2">
			
			<div class="mt-2">
				<h4>Complain Sparepart</h4>
				<table class="table w-100 text-center" v-if="!reloadTable">
					<thead>
						<th>No.</th>
						<th>Nama Sparepart</th>
						<th>Deskripsi</th>
						<th>Tipe Sparepart</th>
						<th><i class="fa fa-cog"/></th>
					</thead>
					<tbody v-for="(estimation , index) in estimationList" :key="index" >
						<tr>
							<td>{{index + 1}}</td>
							<td>{{estimation.sparepart_name}}</td>
							<td>{{estimation.part_number}}</td>
							<td>{{estimation.sparepart_type}}</td>
							<td v-if="!estimation.check"><button class="btn btn-danger" @click="pilihSparepart(index , estimation.sparepart_id , estimation.amount)">Pilih</button></td>
							<td v-else><button class="btn btn-success" @click="cancelSparepart(index, estimation.sparepart_id)">Batal</button></td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="w-100 mt-2">
				<div class="form-group">
					<label>Deskripsi Complain</label>
					<textarea type="text" class="form-control" v-model="data.complain"/>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-md-8 col-6">
			</div>
			<div class="col-md-2 col-3">
				<button type="button" class="btn btn-danger w-100 rounded" @click="$router.push({name : 'ComplainWorkOrder'});">Batal</button>
			</div>
			<div class="col-md-2 col-3">
				<button type="button" class="btn btn-primary w-100 rounded" @click="submitComplain()">Submit</button>
			</div>
		</div>

		<modalImage :modalData="modalData"  @showModalFalse="showImageModal = false" v-if="showImageModal" @uploadImage="uploadImage"/>
	</div>
</template>

<script>
	import moment from 'moment'
	import env from '@/env'

	import modalImage from './children/modalUploadImage'
	export default {
		data () {
			return {
				env,
				mobile : this.isMobile(),
				woDetail : null,
				woFull : null,
				form_code : this.$route.params.id,
				estimationList : null,
				complainSparepartList : [],
				data : {
					complain : '',
					spareparts : []
				},
				reloadTable : false,
				showImageModal : false,
				modalData : null

			}
		},
		components : {
			modalImage
		},
		mounted () {
			this.getWoDetails()
		},
		methods : {
			uploadImage() {
				this.data.spareparts.push(this.modalData)
				this.estimationList[this.modalData.index].check = true
				delete this.modalData.index
				this.showImageModal = false
				this.reloadTable = true
				this.reloadTable = false
			},
			pilihSparepart(index, id, amount) {
				this.modalData = {}
				this.modalData.quantity = parseFloat(amount)
				this.modalData.id = id
				this.modalData.index = index;
				this.modalData.images = null

				this.showImageModal = true

			},
			cancelSparepart(index , id) {
				this.estimationList[index].check = false
				let cancelIndex = this.data.spareparts.findIndex(i => i.id === id);
				this.data.spareparts = this.data.spareparts.splice(cancelIndex , 0)
				this.reloadTable = true
				this.reloadTable = false
			},
			submitComplain() {
				let errorText = []

				if(this.data.spareparts.length <= 0) {
					errorText.push('Tolong Pilih Sparepart Terlebih Dahulu!')
				}
				if(this.data.complain == '') {
					errorText.push('Tolong Isi Deskripsi Terlebih Dahulu!')
				}

				if(errorText.length > 0) {
					this.$store.dispatch('triggerAlert', [false, errorText]);
					return;
				}

				this.$http.post('api/v1/workorder/complaints/' + this.form_code, this.data)
				.then((resp) => {
					this.$store.dispatch('triggerAlert', [true, [`Complain Berhasil Ditambah`]]);
					this.$router.push({name : 'ComplainWorkOrder'})
				})
				.catch((err) => {
					console.log(err)
					this.$store.dispatch('triggerAlert', [false, [err.response.data.data.message]]);
				})
			},
			getWoDetails(){
				this.$http.get(`/api/v1/workorder/${this.form_code}/detail`)
				.then(async (resp)=>{
				var data = resp.data.data;
				let carDetail = this.$store.getters.getModelDetailById(data.customer_car.car_id)
				// console.log(carDetail)

				this.woDetail = {
					work_order_id : this.form_code,
					nomor_mesin : data.customer_car.engine_number,
					nomor_rangka : data.customer_car.chassis_number,
					nomor_polisi : data.customer_car.registration,
					asuransi : data.customer_car.insurance,
					kerusakan : this.evaluateDamage(data.condition.figure),
					tanggal_masuk : moment(data.created_at).format('DD MMM YY HH:mm'),
					pelanggan : data.customer.name,
					cso : data.CSO,
					merek : carDetail.brand_name,
					tipe : carDetail.name,
					image : data.condition.figureOverall.front.image,
					address : data.customer.address,
					warna: data.customer_car.car_color.name,
					tahun : data.customer_car.year,
					car_id : data.customer_car.car.brand_id,
					car_name : data.customer_car.car.name.split(" ")[0]
				}
				// console.log(carDetail)

				this.woFull = data;
				
				// this.imagesList = await this.parseImages(data.condition.figureOverall, data.condition.figure)
				})
				.then(() => {
					this.loadEstimation()
				})
				.catch((err)=>{console.log(err)})
			},
			loadEstimation () {
			this.$http.get('/api/v1/workorder-estimation/' + this.form_code)
				.then((resp)=> {
					let data = resp.data.data
					// console.log(this.estimationData)
					this.estimationList = data.estimations

					for(var i = 0 ; i < this.estimationList.length ; i++) {
						this.estimationList[i].check = false
					}
				})
				.catch((err) => {
					console.log(err)
				})
			},
			evaluateDamage(figure){
				var damages = ""
				for(var i in figure){
				for(var j in figure[i]){
					if(figure[i][j]) damages += `${this.toCapitalizedWords(j)}, `
				}
				}

				return damages ? damages.substring(0, damages.length-2) : '-'
			},
		}
	}
</script>

<style scoped>
  .wo-stats th {
    font-size:16px;
  }
  .wo-stats td {
    padding-left:10px;
  }

  .wo-listing-box {
    margin-top: 20px;
    border:1px solid #4f4f4f;
    border-radius:5px;
  }
  .wo-listing-box .listing-stats{
    font-size: 16px;
    margin: 0;
  }
  .wo-listing-box th {
    font-size:16px;
    padding-right:10px;
  }
  
  .clickAble:hover{
    cursor: pointer;
  }
  .table tbody > tr > td.vert-aligned {
    vertical-align: middle;
	}

	.redStatus {
		background-color : #FB9072;
	}
</style>